const SET_PAGING_LIMIT = 'setPagingLimit'

export const mutationTypes = {
  SET_PAGING_LIMIT
}

export const mutations = {
  [SET_PAGING_LIMIT] (state, payload) {
    state.pagingLimit = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/module/employeeboard/mutations.js